import {useState} from 'react';
import styles from './index.module.scss';
import AddAllDocPowerModal from '@/components/shareCollaborate/AddAllDocPowerModal';
import {
    BatchPowerBtnDisabledSvg,
    BatchPowerBtnSvg,
    CopyToBtnDisabledSvg,
    CopyToBtnSvg,
    MoveToBtnDisabledSvg,
    MoveToBtnSvg,
} from '@/icons';
import Icon, {IconSize} from '@/components/Icon';
import * as store from '@/store';
import classNames from 'classnames';
import toast, {ToastType} from '@/components/Toast';
import {KEYS} from '@/store';
import {clickBatchCopyBtn, clickBatchMoveEntry, feLogger} from '@/buried';
import {GRAY_RELEASE_KEYS, initGray} from '@/grayRelease';
import {DragOption} from '@/interface';

enum btnType {
    addPower = 'addPower',
    copyTo = 'copyTo',
    moveTo = 'moveTo',
}

interface BatchToolProps {
    repository: Repository;
    treeSelectedObj?: any;
    isTreeBatchOperate?: boolean;
    docGuid?: string;
    sidebarDragOption?: DragOption;
}


const {
    useIsInGray: useIsInGrayBatchMove,
} = initGray(GRAY_RELEASE_KEYS.repoBatchMove);

function BatchTool(props: BatchToolProps) {
    const {repository, treeSelectedObj, isTreeBatchOperate, sidebarDragOption, docGuid} = props;
    const [visible, setVisible] = useState(false);

    const {selectedCount = 0} = treeSelectedObj || {};
    const isDisabled = selectedCount === 0;

    const isMoveGray = useIsInGrayBatchMove();

    function handleOnClick(val: string) {
        if (isDisabled) {
            toast({
                content: '请勾选文档后再进行操作',
                duration: 2000,
                type: ToastType.Error,
            });
            return;
        }
        if (val === btnType.addPower) {
            setVisible(true);
        }
        if (val === btnType.copyTo) {
            store.setData(KEYS.COPY_DOCUMENT, {
                type: 1,
                docGuid,
                title: '',
                isSidebar: false,
                hasChild: false,
                timestamp: Date.now(),
                isBatch: true,
            });
            feLogger(clickBatchCopyBtn({
                num: selectedCount || 0,
            }));
        }
        if (val === btnType.moveTo) {
            store.setMoveDocument(docGuid || '', true);
            feLogger(clickBatchMoveEntry({
                num: selectedCount || 0,
            }));
        }
    }

    return <div
        className={classNames(styles.selectAllTool,
            styles.selectAllToolCopy,
            !sidebarDragOption?.sidebarOpen && styles.displayNone,
            isTreeBatchOperate ? styles.enterFromBottom : styles.leaveFromBottom)}
    >
        <div
            className={classNames(styles.modal, isDisabled && styles.disableModal)}
        >
            <div
                className={styles.publicSty}
                onClick={() => handleOnClick(btnType.addPower)}
            >
                <div className={styles.wrapBtn}>
                    <Icon svg={isDisabled ? BatchPowerBtnDisabledSvg : BatchPowerBtnSvg} size={IconSize.Auto} />
                    <div>添加权限</div>
                </div>
            </div>
            <div className={styles.line}></div>
            <div
                className={classNames(styles.publicSty, styles.copyTo)}
                onClick={() => handleOnClick(btnType.copyTo)}
            >
                <div className={styles.wrapBtn}>
                    <Icon svg={isDisabled ? CopyToBtnDisabledSvg : CopyToBtnSvg} size={IconSize.Auto} />
                    <div>复制到</div>
                </div>
            </div>
            {
                isMoveGray
                    ? <>
                        <div className={styles.line}></div>
                        <div
                            className={classNames(styles.publicSty, styles.moveTo)}
                            onClick={() => handleOnClick(btnType.moveTo)}
                        >
                            <div className={styles.wrapBtn}>
                                <Icon svg={isDisabled ? MoveToBtnDisabledSvg : MoveToBtnSvg} size={IconSize.Auto} />
                                <div>移动到</div>
                            </div>
                        </div>
                    </>
                    : null
            }
        </div>
        {
            visible ? <AddAllDocPowerModal
                visible={visible}
                repository={repository}
                onVisibleChange={() => {
                    setVisible(false);
                }}
            /> : null
        }
    </div>;
}

export default store.connect([
    store.KEYS.TREE_SELECTED_OBJ,
    store.KEYS.SIDE_BAR_DRAG_OPTION,
])(BatchTool);
